import React from "react";
import styled from "styled-components";

const TooltipWrapper = styled.div`
  position: relative;

  .tooltiptext {
    visibility: hidden;
    max-width: 194px;
    width: max-content;
    background-color: var(--grey_1);
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 12px;
    position: absolute;
    z-index: 5;
    font-size: 12px;
    font-style: normal;
    font-weight: 450;
    line-height: 16px;
    top: ${({ bottom }) => (bottom ? "120%" : "-150%")};
    right: 0;
    margin-left: -60px;
  }

  .tooltiptext::after {
    content: "";
    position: absolute;
    top: ${({ bottom }) => (bottom ? "-8%" : "90%")};
    left: 50%;
    border-top: 5px solid transparent;
    border-right: 5px solid #000;
    border-bottom: 5px solid transparent;
  }

  &:hover .tooltiptext {
    visibility: ${({ isDisabled }) => (isDisabled ? "visible" : "hidden")};
  }
`;

const AccessTooltip = ({
  children,
  isDisabled,
  bottom,
  text,
  className,
  ...restProps
}) => {
  return (
    <TooltipWrapper
      isDisabled={isDisabled}
      bottom={bottom}
      className={className}
      {...restProps}
    >
      {children}
      <span className="tooltiptext">
        {text || "You do not have permission to perform this action"}
      </span>
    </TooltipWrapper>
  );
};

export default AccessTooltip;
